export type RouteHelpTarget = {
  articleId?: string;
  category?: string;
};

export function getRouteHelpTarget(pathname: string): RouteHelpTarget {
  if (pathname === '/admin') {
    return {
      articleId: 'admin.dashboard.overview',
      category: 'admin.dashboard',
    };
  }

  if (pathname.startsWith('/admin/create') || pathname.startsWith('/admin/edit/')) {
    return {
      articleId: 'outing.create.overview',
      category: 'outing.create',
    };
  }

  if (pathname === '/admin/users') {
    return {
      articleId: 'admin.users.overview',
      category: 'admin.users',
    };
  }

  if (pathname === '/mes-reservations' || pathname.startsWith('/mes-reservations/')) {
    return {
      articleId: 'booking.page.my_bookings',
      category: 'booking.my_bookings',
    };
  }

  if (pathname === '/mes-consentements') {
    return {
      articleId: 'legal.page.consent_settings',
      category: 'legal.consent_settings',
    };
  }

  if (pathname.startsWith('/outing/') || pathname.startsWith('/share/outing/')) {
    return {
      articleId: 'booking.page.outing_detail',
      category: 'booking.page',
    };
  }

  return {};
}
